import { Component } from '@angular/core';

@Component({
  selector: 'jhi-faq',
  templateUrl: './faq.component.html',
})
export class FaqComponent {}
